module.exports = __webpack_public_path__ + "img/app_thumbnail.9d128334.jpg";